import React from "react"
import { Row, Col } from "react-bootstrap"
import Container from "../../components/Layout/Container"
import Wrapper from "../../components/Layout/Wrapper"
import styles from "./ArtworksErrorPage.module.css"
import LikeCards from "../../components/LikeCards"
import { getArtworkSize } from "../../../services/utils/getArtworkSize"
import { linksBuilder } from "../../../services/utils/linksBuilder"
import CustomError from "../../components/CustomError"

const ArtworksErrorPage = ({ status, artwork, relatedArtworks, gallery }) => {
  const getErrorMessage = (status) => {
    switch (status) {
      case 404:
        return (
          <>
            The requested artwork is not available. Please check out these other
            artworks instead!
          </>
        )
      case 403:
        return (
          <>
            <b>{artwork?.title ?? artwork?.id}</b> is no longer available, but
            you may be interested in these artworks:
          </>
        )
      case 500:
      default:
        return "Something went wrong. Please try again later."
    }
  }

  return (
    <Wrapper>
      <Container>
        <Row
          className={`justify-content-center text-black fs-15px fs-mobile-14px ${
            relatedArtworks
              ? styles.artworksErrorPageExtended
              : styles.artworksErrorPage
          }`}>
          <CustomError title={getErrorMessage(status)} />
        </Row>
        {relatedArtworks && (
          <div>
            <Row>
              {relatedArtworks.map((artwork) => (
                <Col key={`like-cards-${artwork.id}`} xs={6} md={4} lg={2}>
                  <LikeCards
                    title={artwork.title}
                    subtitle={artwork.artistname}
                    subSubTitle={getArtworkSize(artwork.width, artwork.height)}
                    image={artwork.image}
                    to={linksBuilder.artworks(
                      gallery?.domain,
                      artwork.id,
                      artwork.title,
                    )}
                    href="/galleries/[id]/artworks/[artwork]"
                    type="aspect-ratio"
                  />
                </Col>
              ))}
            </Row>
          </div>
        )}
      </Container>
    </Wrapper>
  )
}

export default ArtworksErrorPage
